import { NodeSection } from "../props/node/constants";
export var DetachNodeVisitor = {
  NodeTree: function NodeTree(path, state) {
    var _state$opts = state.opts,
      nodeIds = _state$opts.nodeIds,
      removeNode = _state$opts.removeNode;
    if (!removeNode) return;
    this.executeChange(function () {
      nodeIds.forEach(function (nodeId) {
        path.node.detachNode({
          nodeId: nodeId
        });
      });
    });
  },
  Node: {
    enterChild: function enterChild(path) {
      if (path.params.section !== NodeSection.CHILDREN) this.skip();
    }
  },
  AdaptiveDecorator: {
    enterChild: function enterChild(path, state) {
      if (!path.params.matchesInterval(state.opts)) this.skip();
    }
  },
  ListOfIdentifiers: function ListOfIdentifiers(path, state) {
    var _this = this;
    var nodeIds = state.opts.nodeIds;
    nodeIds.forEach(function (nodeId) {
      if (!path.node.hasNode({
        nodeId: nodeId
      })) return;
      _this.executeChange(function () {
        return path.node.detachNode({
          nodeId: nodeId
        });
      });
    });
  }
};